import { withChartLayout } from 'components/common';
import Ostomies from 'components/features/chart/ostomies/Ostomies';

const OstomiesPage = withChartLayout('Ostomies')(Ostomies);
export default OstomiesPage;
